// eslint-disable-next-line import/named
import { ThunkDispatch } from "redux-thunk";
import { showNotification } from "../slices/snackbar/snackbarSlice";
import { axiosHelper, axiosHelperWithToken } from "utils/axios";
import { setUserDetails } from "store/slices/user/userSlice";
import { logout } from 'store/slices/user/userSlice';

export const login = (username: string, password: any, history: any) => {
  return async (dispatch: ThunkDispatch<{}, {}, any>) => {
    return axiosHelper.post('/Users/login', { email: username, password }).then((response) => {
      const data = response.data;
      sessionStorage.setItem('authToken', data.jwtToken);
      dispatch(setUserDetails(data));
      dispatch(showNotification({ message: "Login Successful", variant: "success" }));
      switch (data.userAccounts[0].userType) {
        case "Admin":
          history.push("admin-dashboard");
          break;
        case "Client":
          history.push("client-dashboard");
          break;
        case "Clinician":
          history.push("clinician-dashboard");
          break;
        default:
          break;
      }
    })
      .catch((err) => {
        dispatch(showNotification({ message: String(err && err?.response?.data?.message), variant: "error" }));
      });
  };
}
export const forgotPassword = (username: string, history: any) => {
  return async (dispatch: ThunkDispatch<{}, {}, any>) => {
    return axiosHelper.post('/Users/forgot-password', { email: username }).then((response) => {
      if (response) {
        dispatch(showNotification({ message: response?.data?.message, variant: "success" }));
        history.push('/forgot-password?verified=true');
      }
    })
      .catch((err) => {
        dispatch(showNotification({ message: String(err && err?.data?.message), variant: "error" }));
      });
  };
}

export const resetPassword = (token: string, password: string, history: any) => {
  return async (dispatch: ThunkDispatch<{}, {}, any>) => {
    return axiosHelper.post('/Users/reset-password', { token: token, password, confirmPassword: password }).then((response) => {
      if (response?.data) {
        dispatch(showNotification({ message: response?.data?.message, variant: "success" }));
        history.push('/reset-password?verified=true');
      }
    })
      .catch((err) => {
        dispatch(showNotification({ message: String(err && err?.response?.data?.message), variant: "error" }));
      });
  };
}

export const logoutThunk = (token: string, history: any) => {
  const axios = axiosHelperWithToken();
  return async (dispatch: ThunkDispatch<{}, {}, any>) => {
    return axios.post('/Users/logout', { token }).then(() => {
      dispatch(logout());
      sessionStorage.removeItem('authToken');
      dispatch(showNotification({ message: "Logout Successful", variant: "success" }));
      history.push('/');
    }).catch(() => {
      dispatch(logout());
      sessionStorage.removeItem('authToken');
      dispatch(showNotification({ message: "Logout Successful", variant: "success" }));
      history.push('/');
      //dispatch(showNotification({ message: String(err && err.message), variant: "error" }));
    });
  };
}